module.exports = __webpack_public_path__ + "img/healthbook_white_logo.ed882af2.svg";